/**
 * PURPOSE: Centralizar creación, hidratación, agrupación y orden de entrenamientos en Winscore.
 * RESPONSIBILITIES: Generar clientId estable, sincronizar institución y preparar sortOrder determinista para guardado.
 * COLLABORATORS: TrainingEditor.jsx y CardConfigSportInformation.jsx.
 * ROUTE: winscore/src/components/Cards/CardConfiguration/CardConfigSportInformation/trainingEditor.utils.js
 */

let fallbackCounter = 0;

export const UNDEFINED_TRAINING_DATE = "undefined-date";
export const ALL_TRAINING_DATES = "all";

export const createTrainingClientId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  fallbackCounter += 1;
  return `training-${Date.now()}-${fallbackCounter}`;
};

export const createTraining = (date = "") => ({
  id: null,
  clientId: createTrainingClientId(),
  date,
  startTime: "",
  endTime: "",
  institutionId: "",
  institutionName: "",
  venueId: "",
  notes: "",
  sortOrder: 1,
});

export const hydrateTraining = (training, index, institutionOptions = []) => {
  const institutionId = training.institution?.id
    ? String(training.institution.id)
    : "";
  const catalogInstitution = institutionOptions.find(
    (institution) => String(institution.id) === institutionId,
  );

  return {
    id: training.id || training.idinformationTraining || training.idinformation_training || null,
    clientId: createTrainingClientId(),
    date: training.date || "",
    startTime: training.startTime || "",
    endTime: training.endTime || "",
    institutionId,
    institutionName:
      catalogInstitution?.name ||
      training.institutionName ||
      training.institution?.name ||
      "",
    venueId: training.venue?.id ? String(training.venue.id) : "",
    notes: training.notes || "",
    sortOrder: Number(training.sortOrder) || index + 1,
  };
};

export const formatTrainingDateLabel = (date) => {
  if (!date) return "Por definir";
  const parsed = new Date(`${date}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) return date;
  return parsed.toLocaleDateString("es-PE", {
    day: "2-digit",
    month: "2-digit",
  });
};

export const formatTrainingDateHeading = (date) => {
  if (!date) return "Por definir";
  const parsed = new Date(`${date}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) return date;
  return parsed
    .toLocaleDateString("es-PE", {
      day: "numeric",
      month: "long",
    })
    .toLocaleUpperCase("es-PE");
};

export const getTrainingDateKey = (training) =>
  training.date || UNDEFINED_TRAINING_DATE;

export const sortTrainingDateKeys = (left, right) => {
  if (left === UNDEFINED_TRAINING_DATE) return 1;
  if (right === UNDEFINED_TRAINING_DATE) return -1;
  return left.localeCompare(right);
};

export const orderTrainingsForSave = (trainings) => {
  return trainings
    .map((training, index) => ({ training, index }))
    .sort((left, right) => {
      const leftKey = getTrainingDateKey(left.training);
      const rightKey = getTrainingDateKey(right.training);
      const byDate = sortTrainingDateKeys(leftKey, rightKey);
      if (byDate !== 0) return byDate;

      // El array local es la fuente de verdad del orden visual. Así, “Agregar debajo”
      // conserva la posición elegida incluso antes del primer guardado.
      return left.index - right.index;
    })
    .map(({ training }, index) => ({
      ...training,
      sortOrder: index + 1,
    }));
};
